import Model from '@/common/models/common.model';
import {
  DOMAIN_USER_DOMAIN_ADMIN_ROLE, DOMAIN_USER_PROJECT_MEMBER_ROLE,
  DOMAIN_USER_SERVICE_ACCOUNT_ROLE,
  DOMAIN_USER_SYSTEM_ADMIN_ROLE
} from '@/common/constants/domains.constants';
import { DomainGroup as DomainGroupSchema } from '@schema';

export default class DomainGroup extends Model {
  declare attributes: DomainGroupSchema;

  get domainId() {
    return this.attributes.domain_id;
  }

  get description() {
    return this.attributes.description;
  }

  get role() {
    return this.attributes.role;
  }

  get assignedProjects() {
    return this.attributes.assigned_projects;
  }

  get isDomainAdmin() {
    return this.role === DOMAIN_USER_DOMAIN_ADMIN_ROLE;
  }

  get isServiceUser() {
    return this.role === DOMAIN_USER_SERVICE_ACCOUNT_ROLE;
  }

  get isSystemAdmin() {
    return this.role === DOMAIN_USER_SYSTEM_ADMIN_ROLE;
  }

  get isProjectMember() {
    return this.role === DOMAIN_USER_PROJECT_MEMBER_ROLE;
  }

  get domainPermissions() {
    return this.attributes.domain_permissions;
  }

  get systemPermissions() {
    return this.attributes.system_permissions;
  }

  get membersCount() {
    return this.attributes.members_count;
  }

  get creationTime() {
    return this.attributes.created_at;
  }
}
